import { stopSubmitSpinner, startSubmitSpinner } from './interactions';
import { purchase } from '../../common/api/gifts';
import { trackEvent } from './segmentEvents';

export const SELECT_GIFT_PRODUCT = 'SELECT_GIFT_PRODUCT';
export const SAVE_GIFT_DATA = 'SAVE_GIFT_DATA';
export const EDIT_GIFT = 'EDIT_GIFT';
export const PURCHASE_GIFT_FAILURE = 'PURCHASE_GIFT_FAILURE';
export const PURCHASE_GIFT_SUCCESS = 'PURCHASE_GIFT_SUCCESS';

export const selectGiftProduct = selectedProductId => async (dispatch) => {
  dispatch({ type: SELECT_GIFT_PRODUCT, selectedProductId });
};

export const saveGift = form => async (dispatch) => {
  const { recipientName, recipientEmail } = form;
  const showPaymentForm = true;
  const savedGiftData = {
    ...form,
    recipientEmail: recipientEmail || form.purchaserEmail,
    recipientName: recipientName || form.purchaserName,
  };
  dispatch({ type: SAVE_GIFT_DATA, savedGiftData, showPaymentForm });
};

export const editGift = () => async (dispatch) => {
  const showPaymentForm = false;
  dispatch({ type: EDIT_GIFT, showPaymentForm });
};

export const purchaseGift = gift => async (dispatch) => {
  const { source } = gift;
  dispatch(startSubmitSpinner());
  if (!source) {
    dispatch(stopSubmitSpinner());
    return dispatch({ type: PURCHASE_GIFT_FAILURE, message: 'A valid credit card is required.' });
  }
  try {
    await purchase(gift);
    dispatch(trackEvent('Completed Order - Gift Purchase'));
    dispatch(stopSubmitSpinner());
    return dispatch({ type: PURCHASE_GIFT_SUCCESS });
  } catch (err) {
    const { message } = err;
    dispatch(stopSubmitSpinner());
    return dispatch({ type: PURCHASE_GIFT_FAILURE, message });
  }
};
